import styled from "styled-components";
import Slider from "react-slick";
import { useState, useRef } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faPhoneVolume as faPhone,
  faFileSignature,
  faCalendarCheck,
  faRoad,
  faGasPump,
  faCogs,
  faArrowUpRightFromSquare,
  faBookmark,
  faCarSide,
  faPalette,
  faClose,
  faUpRightAndDownLeftFromCenter,
} from "@fortawesome/free-solid-svg-icons";

// Styled Components
const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex; justify-content: center; align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  position: relative;
  max-width: 90%;
  max-height: 90%;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  overflow: hidden;
`;

const ModalImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 80vh;
  border-radius: 8px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 2px;
  right: 2px;
  background: #e61717;
  border: none;
  color: #ddd;
  padding: 6px 9px;
  border-radius: 8px;
  font-size: 19px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  column-gap: 20px;
  padding: 30px;
  background: #fff;
  border-radius: 20px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 1px;
  }
`;

const MobileSliderWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    margin-bottom: 20px;
  }
`;

const MobileImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
`;

const MobileThumbnails = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: nowrap;
  overflow-x: auto;
`;

const MobileThumbnail = styled.img<{ active: boolean }>`
  width: 60px;
  height: 40px;
  object-fit: cover;
  border-radius: 5px;
  cursor: pointer;
  border: 2px solid ${({ active }) => (active ? "#e61717" : "#ccc")};
  flex-shrink: 0;
`;
const DesktopSliderWrapper = styled.div`
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
`;

const SliderWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 830px;
  margin-bottom: 20px;
  border-radius: 20px;
  overflow: hidden;
  display: block;

  @media (max-width: 768px) {
    max-width: 100%;
    display: none;

  }
`;

const Image = styled.img`
  width: 100%;
  height: 60vh;
  object-fit: cover;

  @media (max-width: 768px) {
    height: 30px;
  }
`;


const IndicatorBar = styled.div`
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 2;
`;

const ZoomIcon = styled.div`
  position: absolute;
  bottom: 15px;
  right: 0px;
  transform: translateX(-50%);
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  color: #e61717;
  background: #ddd;
  gap: 8px;
  z-index: 2;
`;

const Indicator = styled.div<{ active: boolean }>`
  width: 30px;
  height: 4px;
  background-color: ${({ active }) => (active ? "#e61717" : "#ccc")};
  border-radius: 2px;
  transition: background-color 0.3s;
`;

const Thumbnails = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

const Thumbnail = styled.img<{ active: boolean }>`
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid ${({ active }) => (active ? "#e61717" : "#ccc")};
  transition: border 0.2s;

  @media (max-width: 480px) {
    width: 60px;
    height: 45px;
  }

  &:hover {
    opacity: 0.8;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: flex-start;

  @media (max-width: 768px) {
    align-items: center;
    margin-top:20px;
    padding:0 20px 20px;
  }
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  margin-top: -10px;

  @media (max-width: 480px) {
    gap: 4px;
  }
`;

const InfoItem = styled.div`
  padding: 12px 8px;
  text-align: center;
  font-size: 12px;
  color: #7f7f7f;
  display: flex;
  place-items: center;
  justify-content: center;
  gap: 10px;

  svg {
    font-size: 20px;
    color: #4b5563;
  }

  span {
    display: block;
    max-width: 100%;
    overflow: hidden;
    font-size: 17px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const SubText = styled.a`
  font-size: 18px;
  color: #555;
  margin-top: 8px;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const Pricing = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #f6f6f6;
  border-radius: 12px;
  padding: 24px 20px;
  border: 1px solid #ddd;
`;

const Pricings = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #f6f6f6;
  border-radius: 5px;
  border: 1px solid #ddd;

  .yoyo {
    background: #ddd;
    width: 100%;
    border-radius: 5px 5px 0 0;
    text-align: center;
    color: black;
    font-size: 15px;
    padding: 8px;
  }

  .polo {
    padding: 15px;
    text-align: center;
  }
`;

const CallRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
`;

const IconWrapper = styled.div`
  color: #e61717;
  font-size: 20px;
`;

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  border: none;
  padding: 12px 20px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }

  svg {
    font-size: 18px;
  }

  span {
    flex: 1;
    text-align: left;
  }
`;

// Component
const VehicleImageSlider = ({ vehicle }: { vehicle: any }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef<Slider | null>(null);
  const [modalImage, setModalImage] = useState<string | null>(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: false,
    beforeChange: (_: number, next: number) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          swipe: true,
        },
      },
    ],
  };
  

  const handleThumbnailClick = (index: number) => {
    setCurrentSlide(index);
    sliderRef.current?.slickGoTo(index);
  };

  const handleImageClick = (img: string) => {
    setModalImage(img);
  };

  const handleCloseModal = () => {
    setModalImage(null);
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  return (
    <Container>
      <div>
        <DesktopSliderWrapper>
        <SliderWrapper>
          <Slider {...settings} ref={sliderRef}>
            {vehicle.carImages.map((img: string, idx: number) => (
              <Image
                key={idx}
                src={img}
                alt={`Vehicle Image ${idx + 1}`}
                style={{ cursor: "pointer" }}
              />
            ))}
          </Slider>

          <IndicatorBar>
            {vehicle.carImages.map((_: string, idx: number) => (
              <Indicator key={idx} active={idx === currentSlide} />
            ))}
          </IndicatorBar>

          <ZoomIcon
            onClick={() => handleImageClick(vehicle.carImages[currentSlide])}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} />
          </ZoomIcon>
        </SliderWrapper>
        </DesktopSliderWrapper>

        <MobileSliderWrapper>
  <MobileImage
    src={vehicle.carImages[currentSlide]}
    alt={`Vehicle Image ${currentSlide + 1}`}
    onClick={() => handleImageClick(vehicle.carImages[currentSlide])}
    style={{ cursor: "pointer" }}
  />
  {/* <MobileThumbnails>
    {vehicle.carImages.map((img: string, idx: number) => (
      <MobileThumbnail
        key={idx}
        src={img}
        alt={`Thumbnail ${idx + 1}`}
        active={idx === currentSlide}
        onClick={() => handleThumbnailClick(idx)}
      />
    ))}
  </MobileThumbnails> */}
</MobileSliderWrapper>


        <Thumbnails>
          {vehicle.carImages.map((img: string, idx: number) => (
            <Thumbnail
              key={idx}
              src={img}
              alt={`Thumbnail ${idx + 1}`}
              active={idx === currentSlide}
              onClick={() => handleThumbnailClick(idx)}
            />
          ))}
        </Thumbnails>
      </div>

      <ButtonContainer>
        <InfoRow>
          <InfoItem>
            <FontAwesomeIcon icon={faCogs} />
            <span>{vehicle.transmission}</span>
          </InfoItem>
          <InfoItem>
            <FontAwesomeIcon icon={faPalette} />
            <span>{vehicle.extColor}</span>
          </InfoItem>
        </InfoRow>
        <InfoRow>
          <InfoItem>
            <FontAwesomeIcon icon={faRoad} />
            <span>{vehicle.km.toLocaleString()} KM</span>
          </InfoItem>
          <InfoItem>
            <FontAwesomeIcon icon={faCarSide} />
            <span>{vehicle.drivetrain}</span>
          </InfoItem>
        </InfoRow>

        <ActionButton
  style={{ background: "#1c3232" }}
  onClick={() => { window.location.href = "https://godriveauto.ca/calculator"; }}
>

          <FontAwesomeIcon icon={faCalculator} />
          <span>Estimate your payments</span>
        </ActionButton>

        {vehicle.price === "-" ? (
          <Pricing>
            <CallRow>
              <IconWrapper>
                <FontAwesomeIcon icon={faPhone} />
              </IconWrapper>
              <span>Call for pricing</span>
            </CallRow>
            <SubText href="tel:18887189649">1 888 718-9649</SubText>
          </Pricing>
        ) : (
          <Pricings>
            <p className="yoyo">Your Price</p>
            <div className="polo">
              <span style={{ fontSize: 22 }}>$ {vehicle.price}</span>
              <p>+ Tax & Licensing</p>
            </div>
          </Pricings>
        )}

        <ActionButton style={{ background: "#e61717" }}  onClick={() => { window.location.href = "../pre-approval"; }}>
          <FontAwesomeIcon icon={faFileSignature} />
          <span>Get Pre-Approved</span>
        </ActionButton>
        <ActionButton style={{ background: "#1c3232" }} onClick={() => { window.location.href = "https://calendly.com/godriveauto-info/30min"; }}>
          <FontAwesomeIcon icon={faCalendarCheck} />
          <span>Reserve Appointment</span>
        </ActionButton>

        {(vehicle.VIN || vehicle.stock) && (
  <p style={{ marginTop: 5 }}>
    <span style={{ fontFamily: "var(--font-medium)", color: "black" }}>
      {vehicle.VIN && `VIN: ${vehicle.VIN}`}
      {vehicle.VIN && vehicle.stock && ", "}
      {vehicle.stock && `Stock: ${vehicle.stock}`}
      .
    </span>{" "}
    <span style={{ fontStyle: "italic" }}>
      Please note that all prices listed exclude applicable taxes, unless
      otherwise specified. While we make every effort to ensure the
      accuracy of the information provided on our website, we encourage
      you to contact us directly to confirm vehicle details and request
      any additional information you may need.
    </span>
  </p>
)}

      </ButtonContainer>

      {modalImage && (
        <ModalOverlay onClick={handleOverlayClick}>
          <ModalContent>
            <CloseButton onClick={handleCloseModal}>
              <FontAwesomeIcon icon={faClose} />
            </CloseButton>
            <ModalImage src={modalImage} alt="Enlarged vehicle" />
          </ModalContent>
        </ModalOverlay>
      )}
    </Container>
  );
};

export default VehicleImageSlider;
